const config = {
  siteTitle: 'Phil Dibello  Roofing',
  siteTitleShort: 'Dibello Roofing', // Short site title for homescreen (PWA). Preferably should be under 12 characters to prevent truncation.
  siteTitleAlt: 'Phil Dibello Family Roofing', // Alternative site title for SEO.
  siteLogo: '/logo.png', // Logo used for SEO and manifest.
  siteUrl: 'https://www.phildibelloroofing.com', // Domain of your website without pathPrefix.
  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
  siteDescription:
    'A+ Rated &amp; Highly Recommended Roofing, Siding and Windows Company serving Maryland since 1979. Serving Baltimore County, Harford County, Anne Arundel County, Howard County and Carroll County. Contact us online or at 410-752-7663 for a free estimate.', // Website description used for RSS feeds/meta description tag.
  social: {
    youtube: `https://www.youtube.com/channel/UCPkoChf-ageZvOzy8EnoFJQ`,
    yelp: 'https://www.yelp.com/biz/phil-dibello-family-roofing-baltimore',
    twitter: 'https://twitter.com/dibelloroofing',
    facebook: 'https://www.facebook.com/dibelloroofingbaltimore/',
  },
  email: 'info@phildibelloroofing.com',
  copyright: 'Copyright © 2019. Advanced User', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#e31e26', // Used for setting manifest and progress theme colors.
  backgroundColor: '#e31e26', // Used for setting manifest background color.
}

// Validate

// Make sure pathPrefix is empty if not needed
if (config.pathPrefix === '/') {
  config.pathPrefix = ''
} else {
  // Make sure pathPrefix only contains the first forward slash
  config.pathPrefix = `/${config.pathPrefix.replace(/^\/|\/$/g, '')}`
}

module.exports = config
